'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _css2 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 发货按钮及表单：上门自提
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;

var ShipSelf = _react2.default.createClass({
    displayName: 'ShipSelf',
    onOk: function onOk(form) {


        return Promise.resolve();
    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u53D1\u8D27' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u53D1\u8D27\u65B9\u5F0F' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.ship.type
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u81EA\u53D6\u70B9' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        '\u4E0A\u6D77\u5E02 \u4E0A\u6D77\u5E02 \u5F90\u6C47\u533A \u8679\u6865\u8DEF333\u53F7606\u5BA4'
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u8054\u7CFB\u4EBA' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        '\u5F20\u4E09'
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u8054\u7CFB\u7535\u8BDD' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        '13812345678'
                    )
                )
            )
        );
    }
});

exports.default = _form2.default.create()(ShipSelf);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/ship_self.js
// module id = 1316
// module chunks = 0